import { handleActions } from 'redux-actions';
import SET_THEME from './constants';

const theme = handleActions({
  [SET_THEME]: (state, action) => action.payload,
}, 'default');

export default theme;
